/**
 * Report Builder types. See src/reports/filterReport.ts for the filtering
 * logic and README.md ("Report Builder") for the product-level scope notes
 * (county-only data, single-snapshot date semantics, no price-per-sqft yet).
 */

export type ReportFormat = 'pdf' | 'excel' | 'word';

/**
 * All four filters are optional and independent -- the UI never forces an
 * order. Leaving every field blank means "statewide, no restriction."
 */
export interface ReportFilters {
  /** County FIPS geoId, e.g. "48201". */
  countyGeoId?: string;
  /**
   * City slug geoId, e.g. "houston-tx". Texas Market Trends only carries
   * county-level market records (see README), so selecting a city resolves
   * to that city's home county and reports on the county's data -- there is
   * no independent city-level dataset to filter to yet.
   */
  cityGeoId?: string;
  dateStart?: string; // ISO date (yyyy-mm-dd)
  dateEnd?: string; // ISO date (yyyy-mm-dd)
  priceMin?: number;
  priceMax?: number;
}

export function isEmptyFilters(f: ReportFilters): boolean {
  return (
    !f.countyGeoId &&
    !f.cityGeoId &&
    !f.dateStart &&
    !f.dateEnd &&
    f.priceMin == null &&
    f.priceMax == null
  );
}
